import React from 'react'
import PropTypes from 'prop-types'

/**
 * ArrowThinDown svg icon.
 */
const ArrowThinDown = ({ fill }) => (
  <svg width="12" height="6" viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 .365C0 .32.01.275.03.227A.36.36 0 0 1 .118.099.428.428 0 0 1 .403 0c.11 0 .205.033.284.1l5.354 4.994L11.313.177a.402.402 0 0 1 .284-.11c.11 0 .206.036.285.11A.35.35 0 0 1 12 .442a.35.35 0 0 1-.118.265L6.326 5.89A.402.402 0 0 1 6.04 6a.402.402 0 0 1-.284-.11L.118.64A.36.36 0 0 1 .03.515.388.388 0 0 1 0 .364z" fill={fill ? fill : null} fillRule="evenodd" />
  </svg>
)

ArrowThinDown.propTypes = {
  fill: PropTypes.string
}

export default ArrowThinDown
